import React from 'react';
export function EfficiencySection() {
  return <section data-id="element-3143">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3144">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-3145">
          I. Increasing Laser Cutting Efficiency Brings Higher Profits To Your
          Business
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-8" data-id="element-3146">
        <div className="text-center" data-id="element-3147">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/High%20Powered%20Fiber%20Laser%20Comparison.png" alt="High Powered Fiber Laser Comparison" className="block mx-auto max-w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3148" />
        </div>

        <div className="text-gray-700 text-lg leading-relaxed bg-gray-50 p-6 rounded-lg border border-gray-100" data-id="element-3149">
          <p className="mb-4" data-id="element-3150">
            <strong className="text-navy text-xl" data-id="element-3151">Reduce Lead Time |</strong>{' '}
            For laser cutting machines, the higher the power, the faster the
            speed and the higher the efficiency.
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3152">
            <li data-id="element-3153">
              In stainless steel cutting, the processing speed of 12000W (12kW)
              machine is 3.4 times that of 6000W (6kW).
            </li>
            <li data-id="element-3154">
              Cutting efficiency is 6-7 times that of 6kW in material up to 12mm
              when using nitrogen or compressed air.
            </li>
          </ul>
        </div>

        <div className="space-y-12 pt-4" data-id="element-3155">
          <div className="text-center space-y-4" data-id="element-3156">
            <h3 className="text-2xl font-bold text-navy" data-id="element-3157">
              Bodor Laser - 3000w, 6000w and 12000w Fiber Laser Cutting
              Comparison
            </h3>
            <div className="aspect-video w-full max-w-3xl mx-auto rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-3158">
              <iframe className="block w-full h-full" src="https://www.youtube.com/embed/qnnTjMWWnqc?wmode=opaque" title="Bodor Laser - 3000w, 6000w and 12000w Fiber Laser Cutting Comparison" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-3159"></iframe>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-3160">
            <div className="text-center space-y-4" data-id="element-3161">
              <h3 className="text-xl font-bold text-navy" data-id="element-3162">
                Bodor Laser 40kW Fiber Laser
              </h3>
              <div className="aspect-video w-full rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-3163">
                <iframe className="block w-full h-full" src="https://www.youtube.com/embed/tjLo3vzLHo8?wmode=opaque" title="Bodor Laser 40kW Fiber Laser" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-3164"></iframe>
              </div>
            </div>
            <div className="text-center space-y-4" data-id="element-3165">
              <h3 className="text-xl font-bold text-navy" data-id="element-3166">
                Bodor Laser 12kW Fiber Laser Cutting 12mm Carbon Steel
              </h3>
              <div className="aspect-video w-full rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-3167">
                <iframe className="block w-full h-full" src="https://www.youtube.com/embed/rTUoPaF4wGg?wmode=opaque" title="Bodor Laser 12kW Fiber Laser Cutting 12mm Carbon Steel" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-3168"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}